/* tslint:disable */

/**
 */
export class EquipGeneration {
    MOVING_CHANGE?: number;
    ID_EQUIPGENERATION?: number;
    ID_ORIG_EQUIP1?: number;
    ID_ORIG_EQUIP2?: number;
    AVG_PRODINTEMP?: number;
    TEMP_SETPOINT?: number;
    DWELLING_TIME?: number;
    ID_EQUIP?: number;
    MOVING_POS?: number;
    ROTATE?: number;
    POS_CHANGE?: number;
    NEW_POS?: number;
    EQP_GEN_STATUS?: number;
    EQP_GEN_LOADRATE?: number;
    FAN_FREQUENCY?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/equip-generation.ts